var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-youtube {\r\n        fill: none;\r\n        stroke: currentcolor;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 4.49px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    className: "cls-youtube",
    x: 8.18,
    y: 24.56,
    width: 94.2,
    height: 61.43,
    rx: 18.43,
    ry: 18.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    className: "cls-youtube",
    d: "M69.61,55.26l-28.67,14.33v-28.64l28.67,14.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeTop);
export default __webpack_public_path__ + "static/media/youtube-top.598d0274cc140a9adad549c582bfdcdd.svg";
export { ForwardRef as ReactComponent };